import styled from 'styled-components'

const ModalTitle = styled.div`
  margin-bottom: 48px;
  font-weight: 700;
  font-size: 20px;
`

export default ModalTitle
